export default "/_next/static/assets/images/sprite.bf6815ba37fb830af4b35be0feb33398.svg";